import React, { useState } from 'react';
import tw from 'twin.macro';
import { upGradService, supportService } from './data';

type ServiceItem = {
  name: string;
  href: string;
  rel?: number;
  dataTrackerId?: string;
  noFollow?: boolean;
  targetBlank?: boolean;
};

const ServiceWrapper = tw.section``;

const DesktopServiceItem: React.FC<{ name: string; service: ServiceItem[] }> = ({ name, service }) => {
  return (
    <div className="w-full md:w-[50%] md:px-[15px]">
      <p className=" text-center md:text-left text-base leading-[18px] mt-[50px] md:mt-[5px] md:mb-5 uppercase font-medium text-white">
        {name}
      </p>
      <ul className="">
        {service.map(({ name, href }, index) => (
          <li
            key={index}
            className="text-sm text-center md:text-left leading-[15px] cursor-pointer font-light mt-[10px] text-white xl:h-auto"
          >
            <a href={href} target="_blank" rel="noopener noreferrer">
              {name}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

const SectionServices: React.FC = () => {
  return (
    <ServiceWrapper>
      <div className="md:flex-row  flex flex-col w-full ">
        <DesktopServiceItem name="upgrad" service={upGradService} />
        <DesktopServiceItem name="Support" service={supportService} />
      </div>
    </ServiceWrapper>
  );
};

export default SectionServices;
